export default __webpack_public_path__ + "static/2-services-444e63233b4b6799f6b08e49a21063b0.jpg";